import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import configureStore from "./configureStore";
import { RootReducer } from "./rootReducer";

const store = configureStore().store;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootReducer> = useSelector;
